import React, { Component } from 'react';
import ReactTooltip from 'react-tooltip';
import NumberFormat from 'react-number-format';
import logo from './logo.svg';
import './App.css';
import { Bar } from 'react-chartjs-2';

const data = {
  labels: ['Red', 'Pink', 'Yellow', 'Green', 'Purple', 'Orange'],
  datasets: [
    {
      label: '# of Votes',
      data: [12, 19, 3, 5, 2, 3],
      backgroundColor: [
        'rgba(255, 0, 0, 0.2)',
        'rgba(255, 99, 132, 0.2)',
        'rgba(54, 162, 235, 0.2)',
        'rgba(255, 206, 86, 0.2)',
        'rgba(75, 192, 192, 0.2)',
        'rgba(153, 102, 255, 0.2)',
        'rgba(255, 159, 64, 0.2)',
      ],
      borderColor: [
        'rgba(255, 0, 0, 1)',
        'rgba(255, 99, 132, 1)',
        'rgba(54, 162, 235, 1)',
        'rgba(255, 206, 86, 1)',
        'rgba(75, 192, 192, 1)',
        'rgba(153, 102, 255, 1)',
        'rgba(255, 159, 64, 1)',
      ],
      borderWidth: 1,
    },
  ],
}


const sendPostMessage = () => {
  let height = 0;

  if (height !== document.getElementById('risk-calculator-parent').offsetHeight) {
    height = document.getElementById('risk-calculator-parent').offsetHeight;
    window.parent.postMessage({
      frameHeight: height
    }, '*');
    console.log(height);
  }
}



class App extends Component {


  constructor(){
      super();

      sendPostMessage();

      this.state = {
          result: "",
          endpoints: 3000,
          revenue: 600000000,
          businessDays: 250,
          downtimeDays: 10,

          avgEmployeePay: 50000,
          avgAdminPay: 65000,
          timeToRestore: 1,

          alertProbabilityCritical: .01,
          alertProbabilityHigh: .04,
          alertProbabilityMedium: .36,
          alertProbabilityLow: .59,

          alertCoverageCritical: 100,
          alertCoverageHigh: 50,
          alertCoverageMedium: 30,
          alertCoverageLow: 20,

          revenueRisk: 0,
          productivityRisk: 0,
          restorationRisk: 0,
          totalFinancialRisk: 0,

          mitigatedRiskCritical: 0,
          mitigatedRiskHigh: 0,
          mitigatedRiskMedium: 0,
          mitigatedRiskLow: 0,
          mitigatedRiskTotal: 0,
          mitigatedRiskPercent: 0,

          avgWeeklyAlerts: 25000,
          alertsCritical: .001,
          alertsHigh: .009,
          alertsMedium: .29,
          alertsLow: .70,
          alertsFalsePositive: .99,
          alertsEscalated: .001,
          alertsTier12Pay: 70000,
          alertsTier3Pay: 140000,
          alertsAvgTime: 10,

          alertsTier12FTEs: 0,
          alertsTier12Cost: 0,
          alertsTier3FTEs: 0,
          alertsTier3Cost: 0,
          alertsTierFTEsTotal: 0,
          alertsTierCostTotal: 0,

          alertsFalsePositiveNumber: 0,
          alertsFalsePositiveTime: 0,
          alertsEscalatedNumber: 0,
          alertsEscalatedTime: 0,
          alertsNumberTotal: 0,
          alertsTimeTotal: 0,

          showResults: false,
          showResultsComplex: false,
          showResultsComplexToggle: true,

          data: {
            labels: ['Total Financial Risk', 'Accepted Risk'],
            datasets: [
              {
                label: 'Risk  ',
                data: [12, 19, 3, 5, 2, 3],
                backgroundColor: [
                  'rgba(255, 0, 0, 0.2)',
                  'rgba(255, 128, 0, 0.2)',
                  'rgba(255, 99, 132, 0.2)',
                  'rgba(54, 162, 235, 0.2)',
                  'rgba(255, 206, 86, 0.2)',
                  'rgba(75, 192, 192, 0.2)',
                  'rgba(153, 102, 255, 0.2)',
                  'rgba(255, 159, 64, 0.2)',
                ],
                borderColor: [
                  'rgba(255, 0, 0, 1)',
                  'rgba(255, 128, 0, 1)',
                  'rgba(255, 99, 132, 1)',
                  'rgba(54, 162, 235, 1)',
                  'rgba(255, 206, 86, 1)',
                  'rgba(75, 192, 192, 1)',
                  'rgba(153, 102, 255, 1)',
                  'rgba(255, 159, 64, 1)',
                ],
                borderWidth: 1,
              },
            ],
          }
      }

      this.updateEndpoints = this.updateEndpoints.bind(this)
      this.updateRevenue = this.updateRevenue.bind(this)
      this.updateBusinessDays = this.updateBusinessDays.bind(this)
      this.updateDowntimeDays = this.updateDowntimeDays.bind(this)
      this.updateAvgWeeklyAlerts = this.updateAvgWeeklyAlerts.bind(this)
      this.updateAvgAlertResTime = this.updateAvgAlertResTime.bind(this)

      this.updateAlertCoverageCritical = this.updateAlertCoverageCritical.bind(this)
      this.updateAlertCoverageHigh = this.updateAlertCoverageHigh.bind(this)
      this.updateAlertCoverageMedium = this.updateAlertCoverageMedium.bind(this)
      this.updateAlertCoverageLow = this.updateAlertCoverageLow.bind(this)

      this.complexToggleHandler = this.complexToggleHandler.bind(this)
      this.complexSelectionHandler = this.complexSelectionHandler.bind(this)

  }

  componentDidMount() {
     sendPostMessage();
  }

  updateEndpoints(values) {
    this.setState({ endpoints: parseInt(values.value) });
  }

  updateRevenue(values) {
    this.setState({ revenue: parseInt(values.value) });
  }

  updateBusinessDays(values) {
    this.setState({ businessDays: parseInt(values.value) });
  }

  updateDowntimeDays(values) {
    this.setState({ downtimeDays: parseInt(values.value) });
  }

  updateAvgWeeklyAlerts(values) {
    this.setState({ avgWeeklyAlerts: parseInt(values.value) });
  }

  updateAvgAlertResTime(values) {
    this.setState({ alertsAvgTime: parseInt(values.value) });
  }

  updateAlertCoverageCritical(values) {
    this.setState({ alertCoverageCritical: parseInt(values.value) });
  }

  updateAlertCoverageHigh(values) {
    this.setState({ alertCoverageHigh: parseInt(values.value) });
  }

  updateAlertCoverageMedium(values) {
    this.setState({ alertCoverageMedium: parseInt(values.value) });
  }

  updateAlertCoverageLow(values) {
    this.setState({ alertCoverageLow: parseInt(values.value) });
  }

  complexToggleHandler = async (event) => {
    event.preventDefault();
    await this.setState({ showResultsComplexToggle: false });
    sendPostMessage();
  }

  complexSelectionHandler = async (event, value) => {
    event.preventDefault();
    if (!value) {
      await this.setState({ showResultsComplexToggle: true });
      const url = '/contact/';
      window.open(url, '_blank');
    }
    await this.setState({ showResultsComplex: value });
    sendPostMessage();
  }

  submitHandler = async (event) => {
    event.preventDefault();

    if (parseInt(this.state.revenue) <= 0 || this.state.revenue === undefined) {
      alert('Revenue must be greater than 0!');
    } else {

      await this.setState({ revenueRisk: this.state.revenue / this.state.businessDays * this.state.downtimeDays });
      await this.setState({ productivityRisk: ( this.state.endpoints * this.state.avgEmployeePay ) / this.state.businessDays * this.state.downtimeDays });
      await this.setState({ restorationRisk: this.state.endpoints * (this.state.avgAdminPay / this.state.businessDays / 8 ) * this.state.timeToRestore });
      await this.setState({ totalFinancialRisk: this.state.revenueRisk + this.state.productivityRisk  }); //+ this.state.restorationRisk });

      await this.setState({ mitigatedRiskCritical: this.state.totalFinancialRisk * (this.state.alertCoverageCritical / 100) * this.state.alertProbabilityCritical});
      await this.setState({ mitigatedRiskHigh: this.state.totalFinancialRisk * (this.state.alertCoverageHigh / 100) * this.state.alertProbabilityHigh});
      await this.setState({ mitigatedRiskMedium: this.state.totalFinancialRisk * (this.state.alertCoverageMedium / 100) * this.state.alertProbabilityMedium});
      await this.setState({ mitigatedRiskLow: this.state.totalFinancialRisk * (this.state.alertCoverageLow / 100) * this.state.alertProbabilityLow});

      await this.setState({ totalAcceptedRisk: this.state.totalFinancialRisk - this.state.mitigatedRiskCritical - this.state.mitigatedRiskHigh - this.state.mitigatedRiskMedium - this.state.mitigatedRiskLow });

      await this.setState({ mitigatedRiskTotal: this.state.totalFinancialRisk - this.state.totalAcceptedRisk });
      await this.setState({ mitigatedRiskPercent: Math.ceil( ( 1 - ( this.state.totalAcceptedRisk / this.state.totalFinancialRisk )) * 100 ) });

      await this.setState({ alertsFalsePositiveNumber: Math.ceil( (this.state.avgWeeklyAlerts * this.state.alertsCritical * (this.state.alertCoverageCritical / 100) + this.state.avgWeeklyAlerts * this.state.alertsHigh * (this.state.alertCoverageHigh / 100) + this.state.avgWeeklyAlerts * this.state.alertsMedium * (this.state.alertCoverageMedium / 100) + this.state.avgWeeklyAlerts * this.state.alertsLow  * (this.state.alertCoverageLow / 100)) * this.state.alertsFalsePositive ) });
      await this.setState({ alertsEscalatedNumber: Math.ceil( (this.state.avgWeeklyAlerts * this.state.alertsCritical * (this.state.alertCoverageCritical / 100) + this.state.avgWeeklyAlerts * this.state.alertsHigh * (this.state.alertCoverageHigh / 100) + this.state.avgWeeklyAlerts * this.state.alertsMedium * (this.state.alertCoverageMedium / 100) + this.state.avgWeeklyAlerts * this.state.alertsLow  * (this.state.alertCoverageLow / 100)) * this.state.alertsEscalated ) });
      await this.setState({ alertsNumberTotal: this.state.alertsFalsePositiveNumber  + this.state.alertsEscalatedNumber});

      await this.setState({ alertsFalsePositiveTime: Math.ceil(this.state.alertsFalsePositiveNumber * (this.state.alertsAvgTime / 60))});
      await this.setState({ alertsEscalatedTime: Math.ceil(this.state.alertsEscalatedNumber * (this.state.alertsAvgTime / 60))});
      await this.setState({ alertsTimeTotal: this.state.alertsFalsePositiveTime  + this.state.alertsEscalatedTime });

      if (this.state.alertsFalsePositiveTime / 40 < 1) {
        await this.setState({ alertsTier12FTEs: 1 });
      } else {
        await this.setState({ alertsTier12FTEs: Math.ceil(this.state.alertsFalsePositiveTime / 40) });
      }
      await this.setState({ alertsTier12Cost: Math.ceil(this.state.alertsTier12FTEs * this.state.alertsTier12Pay) });

      if (this.state.alertsEscalatedTime / 40 < 1) {
        await this.setState({ alertsTier3FTEs: 1 });
      } else {
        await this.setState({ alertsTier3FTEs: Math.ceil(this.state.alertsEscalatedTime / 40) });
      }
      await this.setState({ alertsTier3Cost: Math.ceil(this.state.alertsTier3FTEs * this.state.alertsTier3Pay) });

      await this.setState({ alertsTierFTEsTotal: this.state.alertsTier12FTEs + this.state.alertsTier3FTEs });
      await this.setState({ alertsTierCostTotal: this.state.alertsTier12Cost + this.state.alertsTier3Cost });

      const currentChartData = this.state.data
      currentChartData.datasets[0].data = new Array(this.state.totalFinancialRisk, this.state.totalAcceptedRisk);
      await this.setState({ data: currentChartData });

      this.setState({ showResults: true });

      sendPostMessage();
    }
  }

  renderResults() {
    return (
            <div>

               <br />
              <h3>Your Risk</h3>

              <div class="pl-6 pr-6 pb-6 bg-white grid grid-cols-1 md:grid-cols-1 gap-4">
                <div class="grid grid-cols-1 gap-6">
                  <div class="col-span-full p-6">
                    <div class="grid grid-cols-1 gap-6">
                      <div id="chartjs">
                        <Bar
                          data={this.state.data}
                          width={100}
                          height={100}
                          options={{
                            maintainAspectRatio: false,
                            scaleLabel: function(label){return  '$' + label.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");},
                            tooltips: {
                                callbacks: {
                                    label: function(tooltipItem, data) {
                                        return "$" + Number(tooltipItem.yLabel).toFixed(0).replace(/./g, function(c, i, a) {
                                            return i > 0 && c !== "." && (a.length - i) % 3 === 0 ? "," + c : c;
                                        });
                                    }
                                }
                            },
                            scales: {
                              yAxes: [{
                                ticks: {
                                  beginAtZero: true,
                                  min: 0,
                                  callback: function(value, index, values) {
                                    if(parseInt(value) >= 1000){
                                      return '$' + value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                                    } else {
                                      return '$' + value;
                                    }
                                  }
                                }
                              }]
                            },
                            legend: {
                                display: false,
                            }
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              { this.state.showResultsComplex ? this.renderComplexResults() : this.renderSimpleResults() }

            </div>
    )
  }

  renderSimpleResults() {
    return (
      <div>
        <div style={{padding: "0% 10% 40px 10%"}}>
              <div class="grid grid-cols-3 gap-6 ">
                <div class="col-span-full p-6">
                  <div class="grid grid-cols-1 gap-6">
                    <div class="text-center">
                      <p>In our experience, businesses like yours currently have a total financial risk of <strong>
                      <NumberFormat
                        displayType={'text'}
                        value={this.state.totalFinancialRisk}
                        thousandSeparator={true}
                        prefix={'$'}
                        /></strong>. We estimate you're spending up to&nbsp;
                        <strong><NumberFormat
                        displayType={'text'}
                        value={this.state.alertsTierCostTotal}
                        thousandSeparator={true}
                        prefix={'$'}
                        /></strong> running your SOC, but have only reduced your overal risk by&nbsp;
                        <strong><NumberFormat
                        displayType={'text'}
                        value={this.state.mitigatedRiskTotal}
                        thousandSeparator={true}
                        prefix={'$'}
                        /></strong> leaving&nbsp;
                        <strong>
                        <NumberFormat
                        displayType={'text'}
                        value={this.state.totalAcceptedRisk}
                        thousandSeparator={true}
                        prefix={'$'}
                        /></strong> still at risk.

                       </p>
                          <br />
                       <p>At the end of the day, spending&nbsp;
                        <strong><NumberFormat
                        displayType={'text'}
                        value={this.state.alertsTierCostTotal}
                        thousandSeparator={true}
                        prefix={'$'}
                        /></strong> to only reduce your risk by&nbsp;
                        <strong><NumberFormat
                        displayType={'text'}
                        value={this.state.mitigatedRiskPercent}
                        thousandSeparator={true}
                        suffix={'%'}
                        /></strong> isn't enough. We can help!

                       </p>
                    </div>
                  </div>
                </div>
              </div>

              { this.state.showResultsComplexToggle ? this.renderComplexToggle() : this.renderComplexSelection() }

              {  }
         </div>
      </div>
    )
  }


  renderComplexToggle() {
    return (
      <div>
        Want to dive deeper?<br /><a onClick={this.complexToggleHandler} class="uk-button uk-button-text">Use the advanced view.</a>
      </div>
    )
  }


  renderComplexSelection() {
    return (
      <div>
        <p>Our advanced view will expand the number of inputs and drill down into the numbers behind our summary. That said, this is a complex subject and we'd love to have one of our MDR experts walk through this with you.</p>

          <br />
              <button onClick={(e) => this.complexSelectionHandler(e, true)} class="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white focus:outline-none">
                Bring the Heat
              </button>

              &nbsp;&nbsp;

              <button onClick={(e) => this.complexSelectionHandler(e, false)} class="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white focus:outline-none">
                Talk to an Expert
              </button>
      </div>
    )
  }

  renderComplexResults() {
        return (
            <div>

            <div class="px-4 py-5 bg-white sm:p-6 grid grid-cols-1 md:grid-cols-2 gap-4">
              <div class="grid grid-cols-3 gap-6">
                <div class="col-span-full p-6">
                  <div class="grid grid-cols-2 gap-6">
                    <div class="text-left">
                       Revenue Risk
                    </div>
                    <div class="text-right">
                       <NumberFormat
                        displayType={'text'}
                        value={Math.round(this.state.revenueRisk)}
                        thousandSeparator={true}
                        prefix={'$'}
                        class="focus:ring-indigo-500 focus:border-indigo-500 flex-1 block w-full sm:text-sm"
                        />
                    </div>
                  </div>
                  <div class="grid grid-cols-2 gap-6">
                    <div class="text-left">
                       Productivity Risk
                    </div>
                    <div class="text-right">
                       <NumberFormat
                        displayType={'text'}
                        value={Math.round(this.state.productivityRisk)}
                        thousandSeparator={true}
                        prefix={'+ $'}
                        class="focus:ring-indigo-500 focus:border-indigo-500 flex-1 block w-full sm:text-sm"
                        />
                    </div>
                  </div>
                  <div class="grid grid-cols-2 gap-6 hidden">
                    <div class="text-left">
                       + Restoration Risk
                    </div>
                    <div class="text-right">
                       <NumberFormat
                        displayType={'text'}
                        value={this.state.restorationRisk}
                        thousandSeparator={true}
                        prefix={'$'}
                        class="focus:ring-indigo-500 focus:border-indigo-500 flex-1 block w-full sm:text-sm"
                        />
                    </div>
                  </div>
                  <div class="grid grid-cols-2 gap-6 border-t-2">
                    <div class="text-left font-bold">
                       <span data-tip data-for='total_risk_info' style={{color: "#0099D9", width: "15px", height: "15px", display: "inline-block"}}><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" /></svg></span>&nbsp;
                       Total Financial Risk
                       <ReactTooltip id='total_risk_info' type='warning' effect='solid' backgroundColor="#0099D9">
                        <span style={{width: "240px", fontWeight: "normal", display: "inline-block"}}>
                          <p>The risk associated with loss revenues and productivity from interrupted business operations.</p><br />
                          <p>Revenue risks from arise from the inability to process and deliver of goods and services when business applications are unavailable. </p><br />
                          <p>Productivity risks arise from employees unable to do their jobs due to interrupted access to business systems and data.</p></span>
                       </ReactTooltip>
                    </div>
                    <div class="text-right font-bold">
                       <NumberFormat
                        displayType={'text'}
                        value={Math.round(this.state.totalFinancialRisk)}
                        thousandSeparator={true}
                        prefix={'$'}
                        class="focus:ring-indigo-500 focus:border-indigo-500 flex-1 block w-full sm:text-sm"
                        />
                    </div>
                  </div>
                </div>
              </div>

              <div class="grid grid-cols-3 gap-6">
                <div class="col-span-full p-6">
                  <div class="grid grid-cols-2 gap-6">
                    <div class="text-left">
                       Total Financial Risk
                    </div>
                    <div class="text-right">
                       <NumberFormat
                        displayType={'text'}
                        value={Math.round(this.state.totalFinancialRisk)}
                        thousandSeparator={true}
                        prefix={'$'}
                        class="focus:ring-indigo-500 focus:border-indigo-500 flex-1 block w-full sm:text-sm"
                        />
                    </div>
                  </div>
                  <div class="grid grid-cols-2 gap-6">
                    <div class="text-left">
                       Mitigated Critical Alerts
                    </div>
                    <div class="text-right">
                       <NumberFormat
                        displayType={'text'}
                        value={Math.round(this.state.mitigatedRiskCritical)}
                        thousandSeparator={true}
                        prefix={'- $'}
                        class="focus:ring-indigo-500 focus:border-indigo-500 flex-1 block w-full sm:text-sm"
                        />
                    </div>
                  </div>
                  <div class="grid grid-cols-2 gap-6">
                    <div class="text-left">
                       Mitigated High Alerts
                    </div>
                    <div class="text-right">
                       <NumberFormat
                        displayType={'text'}
                        value={Math.round(this.state.mitigatedRiskHigh)}
                        thousandSeparator={true}
                        prefix={'- $'}
                        class="focus:ring-indigo-500 focus:border-indigo-500 flex-1 block w-full sm:text-sm"
                        />
                    </div>
                  </div>
                  <div class="grid grid-cols-2 gap-6">
                    <div class="text-left">
                       Mitigated Medium Alerts
                    </div>
                    <div class="text-right">
                       <NumberFormat
                        displayType={'text'}
                        value={Math.round(this.state.mitigatedRiskMedium)}
                        thousandSeparator={true}
                        prefix={'- $'}
                        class="focus:ring-indigo-500 focus:border-indigo-500 flex-1 block w-full sm:text-sm"
                        />
                    </div>
                  </div>
                  <div class="grid grid-cols-2 gap-6">
                    <div class="text-left">
                       Mitigated Low Alerts
                    </div>
                    <div class="text-right">
                       <NumberFormat
                        displayType={'text'}
                        value={Math.round(this.state.mitigatedRiskLow)}
                        thousandSeparator={true}
                        prefix={'- $'}
                        class="focus:ring-indigo-500 focus:border-indigo-500 flex-1 block w-full sm:text-sm"
                        />
                    </div>
                  </div>

                  <div class="grid grid-cols-2 gap-6 border-t-2">
                    <div class="text-left font-bold">
                       <span data-tip data-for='total_accepted_risk_info' style={{color: "#0099D9", width: "15px", height: "15px", display: "inline-block"}}><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" /></svg></span>&nbsp;
                       Total Accepted Risk
                       <ReactTooltip id='total_accepted_risk_info' type='warning' effect='solid' backgroundColor="#0099D9">
                        <span style={{width: "240px", fontWeight: "normal", display: "inline-block"}}>
                          <p>Accepted risk is due to the inability to resolve every alerts.  Traditional MDRs lack the scalability to resolve every alert and apply alert suppression to filter out lower priority alerts. In doing so, they are accepting risk on their client’s behalf. </p><br />
                          <p>Based on a 6-month CRITICAL<strong>START</strong> study, threat actors are launching and hiding new attacks in the noise of lower priority alerts. The Risk Acceptance calculations are based on alerts that we escalated to our clients to take action on:</p><br />
                          <ul>
                            <li>1% of all escalated alerts were Critical priority. </li>
                            <li>4% were High priority</li>
                            <li>26% were Medium priority</li>
                            <li>69% were Low priority</li>
                           </ul></span>
                       </ReactTooltip>
                    </div>
                    <div class="text-right font-bold">
                       <NumberFormat
                        displayType={'text'}
                        value={Math.round(this.state.totalAcceptedRisk)}
                        thousandSeparator={true}
                        prefix={'$'}
                        class="focus:ring-indigo-500 focus:border-indigo-500 flex-1 block w-full sm:text-sm"
                        />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <h3>Your Cost</h3>

            <div class="px-4 py-5 bg-white sm:p-6 grid grid-cols-1 md:grid-cols-2 gap-4">

              <div class="grid grid-cols-3 gap-6">
                <div class="col-span-full p-6">
                  <div class="grid grid-cols-3 gap-6">
                    <div class="text-left">

                    </div>
                    <div class="text-center">
                       <strong># Alerts/week</strong>
                    </div>
                    <div class="text-center">
                       <strong>Time/week (Hrs)</strong>
                    </div>
                  </div>

                  <div class="grid grid-cols-3 gap-6">
                    <div class="text-left">
                      Total False Positives
                    </div>
                    <div class="text-right">
                       <NumberFormat
                        displayType={'text'}
                        value={this.state.alertsFalsePositiveNumber}
                        thousandSeparator={true}
                        class="focus:ring-indigo-500 focus:border-indigo-500 flex-1 block w-full sm:text-sm"
                        />
                    </div>
                    <div class="text-right">
                       <NumberFormat
                        displayType={'text'}
                        value={this.state.alertsFalsePositiveTime}
                        thousandSeparator={true}
                        class="focus:ring-indigo-500 focus:border-indigo-500 flex-1 block w-full sm:text-sm"
                        />
                    </div>
                  </div>

                  <div class="grid grid-cols-3 gap-6">
                    <div class="text-left">
                      Total Escalations
                    </div>
                    <div class="text-right">
                       <NumberFormat
                        displayType={'text'}
                        value={this.state.alertsEscalatedNumber}
                        thousandSeparator={true}
                        class="focus:ring-indigo-500 focus:border-indigo-500 flex-1 block w-full sm:text-sm"
                        />
                    </div>
                    <div class="text-right">
                       <NumberFormat
                        displayType={'text'}
                        value={this.state.alertsEscalatedTime}
                        thousandSeparator={true}
                        class="focus:ring-indigo-500 focus:border-indigo-500 flex-1 block w-full sm:text-sm"
                        />
                    </div>
                  </div>


                  <div class="grid grid-cols-3 gap-6 border-t-2">
                    <div class="text-left">
                      <strong>Totals</strong>
                    </div>
                    <div class="text-right">
                       <strong>
                       <NumberFormat
                        displayType={'text'}
                        value={this.state.alertsNumberTotal}
                        thousandSeparator={true}
                        class="focus:ring-indigo-500 focus:border-indigo-500 flex-1 block w-full sm:text-sm"
                        />
                       </strong>
                    </div>
                    <div class="text-right">
                       <strong>
                       <NumberFormat
                        displayType={'text'}
                        value={this.state.alertsTimeTotal}
                        thousandSeparator={true}
                        class="focus:ring-indigo-500 focus:border-indigo-500 flex-1 block w-full sm:text-sm"
                        />
                       </strong>
                    </div>
                  </div>
                 </div>
                </div>

              <div class="grid grid-cols-3 gap-6">
                <div class="col-span-full p-6">
                  <div class="grid grid-cols-3 gap-6">
                    <div class="text-left">

                    </div>
                    <div class="text-center">
                       <span data-tip data-for='ftes_info' style={{color: "#0099D9", width: "15px", height: "15px", display: "inline-block"}}><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" /></svg></span>&nbsp;
                       <strong>FTEs</strong>
                       <ReactTooltip id='ftes_info' type='warning' effect='solid' backgroundColor="#0099D9">
                        <span style={{width: "240px", textAlign: "left",  fontWeight: "normal", display: "inline-block"}}>
                          <p>Full-Time Equivalents is the number of security professionals needed to investigate and resolve alerts.  It calculates the number of Tier 1 and 2 analysts needed to triage, investigate and escalate. It also calculates the number of Tier 3 analysts needed to investigate and remediate more sophisticated attacks.</p><br />
                          <p>Calculations are based on the average time to investigate and resolve. </p><br />
                          <p>Based on a 6-month CRITICAL<strong>START</strong> study, it assumes that 99% of all alerts are false positives.</p>

                          </span>
                       </ReactTooltip>
                    </div>
                    <div class="text-center">
                       <strong>Annual Cost</strong>
                    </div>
                  </div>

                  <div class="grid grid-cols-3 gap-6">
                    <div class="text-left">
                      Tier 1 & 2
                    </div>
                    <div class="text-right">
                       <NumberFormat
                        displayType={'text'}
                        value={this.state.alertsTier12FTEs}
                        thousandSeparator={true}
                        class="focus:ring-indigo-500 focus:border-indigo-500 flex-1 block w-full sm:text-sm"
                        />
                    </div>
                    <div class="text-right">
                       <NumberFormat
                        displayType={'text'}
                        value={this.state.alertsTier12Cost}
                        thousandSeparator={true}
                        prefix={'$'}
                        class="focus:ring-indigo-500 focus:border-indigo-500 flex-1 block w-full sm:text-sm"
                        />
                    </div>
                  </div>

                  <div class="grid grid-cols-3 gap-6">
                    <div class="text-left">
                      Tier 3
                    </div>
                    <div class="text-right">
                       <NumberFormat
                        displayType={'text'}
                        value={this.state.alertsTier3FTEs}
                        thousandSeparator={true}
                        class="focus:ring-indigo-500 focus:border-indigo-500 flex-1 block w-full sm:text-sm"
                        />
                    </div>
                    <div class="text-right">
                       <NumberFormat
                        displayType={'text'}
                        value={this.state.alertsTier3Cost}
                        thousandSeparator={true}
                        prefix={'$'}
                        class="focus:ring-indigo-500 focus:border-indigo-500 flex-1 block w-full sm:text-sm"
                        />
                    </div>
                  </div>


                  <div class="grid grid-cols-3 gap-6 border-t-2">
                    <div class="text-left">
                      <strong>Totals</strong>
                    </div>
                    <div class="text-right">
                       <strong>
                       <NumberFormat
                        displayType={'text'}
                        value={this.state.alertsTierFTEsTotal}
                        thousandSeparator={true}
                        class="focus:ring-indigo-500 focus:border-indigo-500 flex-1 block w-full sm:text-sm"
                        />
                       </strong>
                    </div>
                    <div class="text-right">
                       <strong>
                       <NumberFormat
                        displayType={'text'}
                        value={this.state.alertsTierCostTotal}
                        thousandSeparator={true}
                        prefix={'$'}
                        class="focus:ring-indigo-500 focus:border-indigo-500 flex-1 block w-full sm:text-sm"
                        />
                       </strong>
                    </div>
                  </div>

                  <div class="hidden">
                  <br /><br />

                  <div class="grid grid-cols-3 gap-6">
                    <div class="text-left">

                    </div>
                    <div class="text-center">
                       <strong># Alerts/week</strong>
                    </div>
                    <div class="text-center">
                       <strong>Time/week (Hrs)</strong>
                    </div>
                  </div>

                  <div class="grid grid-cols-3 gap-6">
                    <div class="text-left">
                      Total False Positives
                    </div>
                    <div class="text-right">
                       <NumberFormat
                        displayType={'text'}
                        value={this.state.alertsFalsePositiveNumber}
                        thousandSeparator={true}
                        class="focus:ring-indigo-500 focus:border-indigo-500 flex-1 block w-full sm:text-sm"
                        />
                    </div>
                    <div class="text-right">
                       <NumberFormat
                        displayType={'text'}
                        value={this.state.alertsFalsePositiveTime}
                        thousandSeparator={true}
                        class="focus:ring-indigo-500 focus:border-indigo-500 flex-1 block w-full sm:text-sm"
                        />
                    </div>
                  </div>

                  <div class="grid grid-cols-3 gap-6">
                    <div class="text-left">
                      Total Escalations
                    </div>
                    <div class="text-right">
                       <NumberFormat
                        displayType={'text'}
                        value={this.state.alertsEscalatedNumber}
                        thousandSeparator={true}
                        class="focus:ring-indigo-500 focus:border-indigo-500 flex-1 block w-full sm:text-sm"
                        />
                    </div>
                    <div class="text-right">
                       <NumberFormat
                        displayType={'text'}
                        value={this.state.alertsEscalatedTime}
                        thousandSeparator={true}
                        class="focus:ring-indigo-500 focus:border-indigo-500 flex-1 block w-full sm:text-sm"
                        />
                    </div>
                  </div>


                  <div class="grid grid-cols-3 gap-6 border-t-2">
                    <div class="text-left">
                      <strong>Totals</strong>
                    </div>
                    <div class="text-right">
                       <strong>
                       <NumberFormat
                        displayType={'text'}
                        value={this.state.alertsNumberTotal}
                        thousandSeparator={true}
                        class="focus:ring-indigo-500 focus:border-indigo-500 flex-1 block w-full sm:text-sm"
                        />
                       </strong>
                    </div>
                    <div class="text-right">
                       <strong>
                       <NumberFormat
                        displayType={'text'}
                        value={this.state.alertsTimeTotal}
                        thousandSeparator={true}
                        class="focus:ring-indigo-500 focus:border-indigo-500 flex-1 block w-full sm:text-sm"
                        />
                       </strong>
                    </div>
                  </div>
                  </div>
                </div>
              </div>


              <div class="grid grid-cols-3 gap-6 hidden">
                <div class="col-span-full p-6">
                  <div class="grid grid-cols-1 gap-6">
                    <div class="text-center">
                      <h1 >What does it all mean?</h1>
                      <br />
                      <p>In our experience, it means that businesses like yours currently have a total financial risk exposure of <strong>
                      <NumberFormat
                        displayType={'text'}
                        value={this.state.totalFinancialRisk}
                        thousandSeparator={true}
                        prefix={'$'}
                        /></strong>. We estimate you're spending up to&nbsp;
                        <strong><NumberFormat
                        displayType={'text'}
                        value={this.state.alertsTierCostTotal}
                        thousandSeparator={true}
                        prefix={'$'}
                        /></strong> running your SOC, but have only reduced your overal risk&nbsp;
                        <strong><NumberFormat
                        displayType={'text'}
                        value={this.state.mitigatedRiskTotal}
                        thousandSeparator={true}
                        prefix={'$'}
                        /></strong> leaving&nbsp;
                        <strong>
                        <NumberFormat
                        displayType={'text'}
                        value={this.state.totalAcceptedRisk}
                        thousandSeparator={true}
                        prefix={'$'}
                        /></strong> still at risk.

                       </p>
                          <br />
                       <p>At the end of the day, spending&nbsp;
                        <strong><NumberFormat
                        displayType={'text'}
                        value={this.state.alertsTierCostTotal}
                        thousandSeparator={true}
                        prefix={'$'}
                        /></strong> to only reduce your risk by&nbsp;
                        <strong><NumberFormat
                        displayType={'text'}
                        value={this.state.mitigatedRiskPercent}
                        thousandSeparator={true}
                        suffix={'%'}
                        /></strong> isn't enough. We can help!

                       </p>
                    </div>
                  </div>
                </div>
              </div>

            </div>

            <br />
            <h3>Compared to CRITICAL<strong>START</strong></h3>

            <div class="pl-6 pr-6 bg-white grid grid-cols-1 md:grid-cols-2 gap-4">
              <div class="grid grid-cols-3 gap-6">
                <div class="col-span-full p-6">
                  <div class="grid grid-cols-1 gap-6">
                    <div class="text-left">
                      <p>CRITICAL<strong>START</strong>’s unique and leading-edge Trust-Oriented model is based on resolving every alert, the only way to reduce risk with confidence.  Our proprietary Zero Trust Analytics Platform and Trusted Behavior Registry delivers the scalability to resolve every alert by eliminating false positives which accounts for 99% of all alerts. Our SOC team provides the security expertise to reduce the alert we escalate to our clients to only 0.1% of all alerts.</p>
                    </div>
                  </div>
                </div>
              </div>


              <div class="grid grid-cols-3 gap-6">
                <div class="col-span-full p-6">

                  <div class="grid grid-cols-3 gap-6">
                    <div class="text-left col-span-2 ">
                      Total alerts
                    </div>
                    <div class="text-right">
                       <NumberFormat
                        displayType={'text'}
                        value={this.state.avgWeeklyAlerts}
                        thousandSeparator={true}
                        class="focus:ring-indigo-500 focus:border-indigo-500 flex-1 block w-full sm:text-sm"
                        />
                    </div>
                  </div>

                  <div class="grid grid-cols-3 gap-6">
                    <div class="text-left col-span-2 ">
                      <p>Alerts Auto-resolved by ZTAP:</p>
                    </div>
                    <div class="text-right">
                       <NumberFormat
                        displayType={'text'}
                        value={Math.round(this.state.avgWeeklyAlerts * .01)}
                        thousandSeparator={true}
                        class="focus:ring-indigo-500 focus:border-indigo-500 flex-1 block w-full sm:text-sm"
                        />
                    </div>
                  </div>


                  <div class="grid grid-cols-3 gap-6">
                    <div class="text-left col-span-2 ">
                      <p>Alerts escalated:</p>
                    </div>
                    <div class="text-right">
                       <strong>
                       <NumberFormat
                        displayType={'text'}
                        value={Math.round(this.state.avgWeeklyAlerts * .001)}
                        thousandSeparator={true}
                        class="focus:ring-indigo-500 focus:border-indigo-500 flex-1 block w-full sm:text-sm"
                        />
                       </strong>
                    </div>
                  </div>


                  <div class="grid grid-cols-3 gap-6">
                    <div class="text-left col-span-2 ">
                      FTEs:
                    </div>
                    <div class="text-right">
                       <strong>
                       <NumberFormat
                        displayType={'text'}
                        value={(this.state.avgWeeklyAlerts * .001 / 40).toFixed(1)}
                        thousandSeparator={true}
                        class="focus:ring-indigo-500 focus:border-indigo-500 flex-1 block w-full sm:text-sm"
                        />
                       </strong>
                    </div>
                  </div>


                  <div class="grid grid-cols-3 gap-6">
                    <div class="text-left col-span-2 ">
                      Total Costs:
                    </div>
                    <div class="text-right">
                       <strong>
                       <NumberFormat
                        displayType={'text'}
                        value={Math.round((this.state.avgWeeklyAlerts * .001 / 40).toFixed(1) * this.state.alertsTier3Pay)}
                        thousandSeparator={true}
                        prefix={'$'}
                        class="focus:ring-indigo-500 focus:border-indigo-500 flex-1 block w-full sm:text-sm"
                        />
                       </strong>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="pl-6 pr-6 pb-6 bg-white grid grid-cols-1 md:grid-cols-1 gap-4">
              <div class="grid grid-cols-3 gap-6">
                <div class="col-span-full p-6">
                  <div class="grid grid-cols-1 gap-6">
                    <div class="text-center px-20">
                      <p>CRITICAL<strong>START</strong> reduces endpoint risk to levels unachievable by traditional Managed Detection and Response (MDR) service providers and security tools alone. </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>



            </div>
        );
  }

  renderAdditionalFields() {
      return (
              <div>
              <h3>Alert Information</h3>
              <div class="px-4 py-5 bg-white sm:p-6 grid grid-cols-1 md:grid-cols-2 gap-4">

                  <div class="grid grid-cols-3 gap-6">
                    <div class="col-span-full">
                      <label for="alert_coverage_critical" class="block text-sm font-medium text-gray-700 text-left">
                        <span data-tip data-for='coverage_critical_info' style={{color: "#0099D9", width: "15px", height: "15px", display: "inline-block"}}><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" /></svg></span>&nbsp;
                        % Critical Alerts Resolved
                      </label>
                      <ReactTooltip id='coverage_critical_info' type='warning' effect='solid' backgroundColor="#0099D9">
                        <span style={{width: "240px", display: "inline-block"}}>Percent of Critical alerts you currently investigate and resolve. Based on a 6-month CRITICAL<strong>START</strong> study, 0.1% of all alerts a assigned a Critical priority.</span>
                      </ReactTooltip>
                      <NumberFormat
                        name="alert_coverage_critical"
                        id="alert_coverage_critical"
                        defaultValue={this.state.alertCoverageCritical}
                        onValueChange={this.updateAlertCoverageCritical}
                        suffix={'%'}
                        thousandSeparator={true}
                        class="focus:ring-indigo-500 focus:border-indigo-500 flex-1 block w-full sm:text-sm"
                       />
                    </div>
                  </div>

                  <div class="grid grid-cols-3 gap-6">
                    <div class="col-span-full">
                      <label for="alert_coverage_high" class="block text-sm font-medium text-gray-700 text-left">
                        <span data-tip data-for='coverage_critical_high_info' style={{color: "#0099D9", width: "15px", height: "15px", display: "inline-block"}}><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" /></svg></span>&nbsp;
                        % High Alerts Resolved
                      </label>
                      <ReactTooltip id='coverage_critical_high_info' type='warning' effect='solid' backgroundColor="#0099D9">
                        <span style={{width: "240px", display: "inline-block"}}>Percent of Critical alerts you currently investigate and resolve. Based on a 6-month CRITICAL<strong>START</strong> study, 0.9% of all alerts assigned a High priority.</span>
                      </ReactTooltip>
                      <NumberFormat
                        name="alert_coverage_high"
                        id="alert_coverage_high"
                        defaultValue={this.state.alertCoverageHigh}
                        onValueChange={this.updateAlertCoverageHigh}
                        suffix={'%'}
                        thousandSeparator={true}
                        class="focus:ring-indigo-500 focus:border-indigo-500 flex-1 block w-full sm:text-sm"
                       />
                    </div>
                  </div>

                  <div class="grid grid-cols-3 gap-6">
                    <div class="col-span-full">
                      <label for="alert_coverage_medium" class="block text-sm font-medium text-gray-700 text-left">
                        <span data-tip data-for='coverage_critical_medium_info' style={{color: "#0099D9", width: "15px", height: "15px", display: "inline-block"}}><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" /></svg></span>&nbsp;
                        % Medium Alerts Resolved
                      </label>
                      <ReactTooltip id='coverage_critical_medium_info' type='warning' effect='solid' backgroundColor="#0099D9">
                        <span style={{width: "240px", display: "inline-block"}}>Percent of Critical alerts you currently investigate and resolve. Based on a 6-month CRITICAL<strong>START</strong>, study 29% of all alerts assigned a Medium priority.</span>
                      </ReactTooltip>
                      <NumberFormat
                        name="alert_coverage_medium"
                        id="alert_coverage_medium"
                        defaultValue={this.state.alertCoverageMedium}
                        onValueChange={this.updateAlertCoverageMedium}
                        suffix={'%'}
                        thousandSeparator={true}
                        class="focus:ring-indigo-500 focus:border-indigo-500 flex-1 block w-full sm:text-sm"
                       />
                    </div>
                  </div>

                  <div class="grid grid-cols-3 gap-6">
                    <div class="col-span-full">
                      <label for="alert_coverage_low" class="block text-sm font-medium text-gray-700 text-left">
                        <span data-tip data-for='coverage_critical_low_info' style={{color: "#0099D9", width: "15px", height: "15px", display: "inline-block"}}><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" /></svg></span>&nbsp;
                        % Low Alerts Resolved
                      </label>
                      <ReactTooltip id='coverage_critical_low_info' type='warning' effect='solid' backgroundColor="#0099D9">
                        <span style={{width: "240px", display: "inline-block"}}>Percent of Critical alerts you currently investigate and resolve. Based on a 6-month CRITICAL<strong>START</strong> study, 70% of all alerts assigned a Low priority.</span>
                      </ReactTooltip>
                      <NumberFormat
                        name="alert_coverage_low"
                        id="alert_coverage_low"
                        defaultValue={this.state.alertCoverageLow}
                        onValueChange={this.updateAlertCoverageLow}
                        suffix={'%'}
                        thousandSeparator={true}
                        class="focus:ring-indigo-500 focus:border-indigo-500 flex-1 block w-full sm:text-sm"
                       />
                    </div>
                  </div>

                  <div class="grid md:grid-cols-3 gap-6">
                    <div class="col-span-full">
                      <label for="avg_weekly_alerts" class="block text-sm font-medium text-gray-700 text-left">
                        <span data-tip data-for='avg_weekly_alerts_info' style={{color: "#0099D9", width: "15px", height: "15px", display: "inline-block"}}><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" /></svg></span>&nbsp;
                        Avg. Weekly Alerts
                      </label>
                      <ReactTooltip id='avg_weekly_alerts_info' type='warning' effect='solid' backgroundColor="#0099D9">
                        <span style={{width: "240px", display: "inline-block"}}>Based on a 6-month CRITICAL<strong>START</strong> study, an average of 100,000 alerts per client per week are generated when security tools are tuned to collect every alert.</span>
                      </ReactTooltip>
                      <NumberFormat
                        name="avg_weekly_alerts"
                        id="avg_weekly_alerts"
                        defaultValue={this.state.avgWeeklyAlerts}
                        onValueChange={this.updateAvgWeeklyAlerts}
                        thousandSeparator={true}
                        class="focus:ring-indigo-500 focus:border-indigo-500 flex-1 block w-full sm:text-sm"
                       />
                    </div>
                  </div>

                  <div class="grid grid-cols-3 gap-6">
                    <div class="col-span-full">
                      <label for="avg_alert_res_time" class="block text-sm font-medium text-gray-700 text-left">
                        <span data-tip data-for='avg_alert_res_time_info' style={{color: "#0099D9", width: "15px", height: "15px", display: "inline-block"}}><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" /></svg></span>&nbsp;
                        Avg. investigation and resolution time (mins)
                      </label>
                      <ReactTooltip id='avg_alert_res_time_info' type='warning' effect='solid' backgroundColor="#0099D9">
                        <span style={{width: "240px", display: "inline-block"}}>The average time for an experienced SOC Analysts to investigate and resolve and alert.</span>
                      </ReactTooltip>
                      <NumberFormat
                        name="avg_alert_res_time"
                        id="avg_alert_res_time"
                        defaultValue={this.state.alertsAvgTime}
                        onValueChange={this.updateAvgAlertResTime}
                        thousandSeparator={true}
                        class="focus:ring-indigo-500 focus:border-indigo-500 flex-1 block w-full sm:text-sm"
                        />
                    </div>
                  </div>
              </div>
              </div>
        )
  }

  render() {
    return (
    <div className="App" id="risk-calculator">

  <div>{ this.state.result}
    <div class="">
      <div class="">
        <form onSubmit={this.submitHandler}>
          <div class="sm:overflow-hidden">
            <h3>{ this.state.showResultsComplex ? "Business Info" : "" }</h3>
            <div class="px-4 py-5 bg-white sm:p-6 grid grid-cols-1 md:grid-cols-2 gap-4">
              <div class="grid md:grid-cols-3 gap-6">
                <div class="col-span-full">
                  <label for="endpoints" class="block text-sm font-medium text-gray-700 text-left">
                    <span data-tip data-for='endpoints_info' style={{color: "#0099D9", width: "15px", height: "15px", display: "inline-block"}}><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" /></svg></span>&nbsp;
                    Endpoints
                  </label>
                  <ReactTooltip id='endpoints_info' type='warning' effect='solid' backgroundColor="#0099D9">
                    <span style={{width: "240px", display: "inline-block"}}>The number of employees who cannot perform their duties due to interruption of business operations</span>
                  </ReactTooltip>
                  <NumberFormat
                    name="endpoints"
                    id="endpoints"
                    defaultValue={this.state.endpoints}
                    onValueChange={this.updateEndpoints}
                    thousandSeparator={true}
                    class="focus:ring-indigo-500 focus:border-indigo-500 flex-1 block w-full sm:text-sm"
                   />
                </div>
              </div>

              <div class="grid grid-cols-3 gap-6">
                <div class="col-span-full">
                  <label for="revenue" class="block text-sm font-medium text-gray-700 text-left">
                    <span data-tip data-for='revenue_info' style={{color: "#0099D9", width: "15px", height: "15px", display: "inline-block"}}><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" /></svg></span>&nbsp;
                    Annual Revenue
                  </label>
                  <ReactTooltip id='revenue_info' type='warning' effect='solid' backgroundColor="#0099D9">
                    <span style={{width: "240px", display: "inline-block"}}>The annual revenues at risk due to interruption of business operations</span>
                  </ReactTooltip>
                  <NumberFormat
                    name="revenue"
                    id="revenue"
                    defaultValue={this.state.revenue}
                    onValueChange={this.updateRevenue}
                    thousandSeparator={true}
                    prefix={'$'}
                    class="focus:ring-indigo-500 focus:border-indigo-500 flex-1 block w-full sm:text-sm"
                    />
                </div>
              </div>

              <div class="grid grid-cols-3 gap-6">
                <div class="col-span-full">
                  <label for="business_days" class="block text-sm font-medium text-gray-700 text-left">
                    <span data-tip data-for='business_days_info' style={{color: "#0099D9", width: "15px", height: "15px", display: "inline-block"}}><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" /></svg></span>&nbsp;
                    Business Days
                  </label>
                  <ReactTooltip id='business_days_info' type='warning' effect='solid' backgroundColor="#0099D9">
                    <span style={{width: "240px", display: "inline-block"}}>Days/year open for business. 250 days for businesses open on weekdays. 360 days for businesses open on weekdays and weekends.</span>
                  </ReactTooltip>
                  <NumberFormat
                    name="business_days"
                    id="business_days"
                    defaultValue={this.state.businessDays}
                    onValueChange={this.updateBusinessDays}
                    thousandSeparator={true}
                    class="focus:ring-indigo-500 focus:border-indigo-500 flex-1 block w-full sm:text-sm"
                   />
                </div>
              </div>

              <div class="grid grid-cols-3 gap-6">
                <div class="col-span-full">
                  <label for="downtime_days" class="block text-sm font-medium text-gray-700 text-left">
                    <span data-tip data-for='downtime_days_info' style={{color: "#0099D9", width: "15px", height: "15px", display: "inline-block"}}><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" /></svg></span>&nbsp;
                    Estimated Downtime (Days)
                  </label>
                  <ReactTooltip id='downtime_days_info' type='warning' effect='solid' backgroundColor="#0099D9">
                    <span style={{width: "240px", display: "inline-block"}}>Anticipated downtime from as ransomware attack. Industry experts estimate average downtime as high as 16 days.</span>
                  </ReactTooltip>
                  <NumberFormat
                    name="downtime_days"
                    id="downtime_days"
                    defaultValue={this.state.downtimeDays}
                    onValueChange={this.updateDowntimeDays}
                    thousandSeparator={true}
                    class="focus:ring-indigo-500 focus:border-indigo-500 flex-1 block w-full sm:text-sm"
                   />
                </div>
              </div>
            </div>
              { this.state.showResultsComplex ? this.renderAdditionalFields() : null }


            <div class="px-4 py-3 text-right sm:px-6">
              <button type="submit" class="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white focus:outline-none">
                { this.state.showResults ? 'Update' : 'Submit' }
              </button>
            </div>


            { this.state.showResults ? this.renderResults() : null }

          </div>
        </form>
      </div>
    </div>
  </div>

    </div>
    );
  }
}

export default App;
